import { render, staticRenderFns } from "./updateExamineeDialog.vue?vue&type=template&id=370c94d6&scoped=true"
import script from "./updateExamineeDialog.vue?vue&type=script&lang=js"
export * from "./updateExamineeDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370c94d6",
  null
  
)

export default component.exports